"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.propTypes = exports.defaultProps = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _grid = require("@bootstrap-styled/css-mixins/lib/grid");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *Definition List
 *
 */
var defaultProps = {
  theme: {
    '$grid-gutter-width': '30px',
    '$enable-grid-classes': true
  }
};
exports.defaultProps = defaultProps;
var propTypes = {
  /** Theme variables. Can be: */
  theme: _propTypes.default.shape({
    '$grid-gutter-width': _propTypes.default.string,
    '$enable-grid-classes': _propTypes.default.bool
  })
};
/**
 * `<Dl />` defines a description list.
 */

exports.propTypes = propTypes;

var Dl = _styledComponents.default.dl.withConfig({
  displayName: "Dl",
  componentId: "cr4d3a-0"
})(["  margin-top:0;margin-bottom:1rem;", ""], function (props) {
  return "\n    ".concat((0, _grid.makeRow)(props.theme['$enable-grid-classes'], props.theme['$grid-gutter-width']), "\n  ");
});

Dl.defaultProps = defaultProps;
Dl.propTypes = propTypes;
/** @component */

var _default = Dl;
exports.default = _default;